// ---------------------------------------------- modules import
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FirebaseReducer, isEmpty, isLoaded } from "react-redux-firebase";

import { AppState } from "../store/rootReducer";
import { IUserData } from "../store/firebase/common";
import ThemeHelper from "../store/helpers/themeHelper";

export const useThemeContext = () => {
  // ---------------------------------------------- redux connect
  const auth = useSelector(
    (state: AppState) =>
      (state.firebase as FirebaseReducer.Reducer<
        Record<string, Record<string | number, string | number>>,
        IUserData
      >).auth
  );
  const profile = useSelector(
    (state: AppState) =>
      (state.firebase as FirebaseReducer.Reducer<
        Record<string, Record<string | number, string | number>>,
        IUserData
      >).profile
  );

  // ---------------------------------------------- local state
  const [areLoaded, setAreLoaded] = useState(
    isLoaded(auth) && isLoaded(profile)
  );
  const [isEmptied, setIsEmptied] = useState(isEmpty(auth) || isEmpty(profile));
  const [theme, setTheme] = useState(ThemeHelper.getTheme(profile.themeIndex));

  // ---------------------------------------------- handlers
  const handleChange = (index: number) => setTheme(ThemeHelper.getTheme(index));

  // ---------------------------------------------- effects
  useEffect(() => {
    setAreLoaded(isLoaded(auth) && isLoaded(profile));
    setIsEmptied(isEmpty(auth) || isEmpty(profile));
  }, [auth, profile]);

  useEffect(() => {
    if (areLoaded && !isEmptied)
      setTheme(ThemeHelper.getTheme(profile.themeIndex));
  }, [areLoaded, isEmptied, profile]);
  // ---------------------------------------------- return value
  return {
    theme,
    onChange: handleChange
  };
};
